import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectAssetPageRoutingModule } from './select-asset-routing.module';

import { SelectAssetPage } from './select-asset.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SelectAssetPageRoutingModule
  ],
  declarations: [SelectAssetPage]
})
export class SelectAssetPageModule {}
